import { cx } from '@mage-ui/styled-system/css';
import { columnText, text, textStyles } from '@mage-ui/styled-system/recipes';

//TextColumn
export const ColumnText = ({ data, isRelation, hasParentTitle, ...props }) => {
  const TagRelation = hasParentTitle ? (isRelation ? 'h4' : 'h3') : 'p';

  return (
    <div className={columnText().root} {...props}>
      {data?.fields?.title ||
        (data?.title && (
          <TagRelation
            className={cx(
              text({ size: '2', weight: 'bold' }),
              columnText().title,
            )}
          >
            {data?.fields?.title || data?.title}
          </TagRelation>
        ))}
      {data?.fields?.text ||
        (data.text && (
          <div
            className={cx(columnText().contentWrapper, textStyles())}
            dangerouslySetInnerHTML={{
              __html: data?.fields?.text || data?.text,
            }}
          />
        ))}
    </div>
  );
};
